import React, { useState } from "react";
import Container from "./Container";
import ContactForm from "./ContactForm";
import "../styles/ContactUs.css";
import { Helmet ,HelmetProvider} from "react-helmet-async";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGlobe } from "react-icons/fa";

const ContactUs = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
    <HelmetProvider>
      <Helmet>
        <meta
          name="description"
          content="Get in touch with INBI NextGen Innovations. Reach us at Sakina Plaza, Karkala, Karnataka. Call +91 73380 57667 or email info@inbinextgen.com for software, IoT & ERP solutions."
        />
        <meta
          name="keywords"
          content="contact INBI NextGen Innovations, software support India, IoT company contact, ERP solutions contact"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"
        />
        <meta
          property="og:description"
          content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 years of expertise. Contact us today."
        />
        <meta property="og:image" content="/assets/ContactUs.svg" />
        <meta property="og:url" content="https://inbinextgen.com/#join-us" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta
          name="twitter:title"
          content="INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"
        />
        <meta
          name="twitter:description"
          content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 years of expertise. Contact us today."
        />
        <meta name="twitter:image" content="/assets/Logoblue.jpg" />
      </Helmet>
    </HelmetProvider>
      

      <section id="contact-us" className="join-us-section">
        <Container className="join-us-container">
          {/* Left side - Image */}
          <div className="join-us-image">
            <img
              src="/assets/ContactUs.svg"
              alt="Get in touch with INBI NextGen Innovations Private Limited"
            />
          </div>

          {/* Right side - Text */}
          <div className="join-us-text">
            <h2>Contact Us</h2>
            <p>
              <b>Let’s Build the Future Together</b>
              <br />
              For inquiries or to share an innovative idea, contact us. We are
              always eager to hear from you. Partner with INBI NextGen
              Innovations and turn your ideas into reality.
            </p>

            
              <small>
                <div id="Main-line">
                  <b>INBI NextGen Innovations Private Limited</b>
                </div>
                <div id="Adress-contant">
                  <FaMapMarkerAlt className="map-1" />
                  <FaMapMarkerAlt className="map-2" />
                    Sakina Plaza, Mangaluru Road, Karkala, Udupi District,
                    Karnataka, INDIA – 574104
                </div>

                <div>
                  <FaEnvelope className="contact-us-icon" />&nbsp;&nbsp;info@inbinextgen.com
                </div>
                <div>
                  <FaGlobe className="contact-us-icon" />&nbsp;&nbsp;inbinextgen.com
                </div>
                <div>
                  <FaPhone className="contact-us-icon" />&nbsp;&nbsp;+91 73380 57667
                </div>
              </small>
            

            <button
              className="cta-btn-contactus"
              onClick={() => setShowForm(true)}
            >
              Send Us a Message
            </button>
          </div>
        </Container>

        {showForm && <ContactForm onClose={() => setShowForm(false)} />}
      </section>
    </>
  );
};

export default ContactUs;
